import Cookies from "js-cookie";
import { httpService } from "@/services/api";
import { removeFormatting } from "@/utils";
import * as workspaceService from "../workspaces";
import Swal from "sweetalert2";

export const EMPTY_USER = {
  personalName: null,
  isLoggedIn: false,
  workspaces: [],
};

export const setUser = (user) => {
  localStorage.setItem(
    process.env.REACT_APP_CURRENT_USER,
    JSON.stringify(user)
  );
};

export const setIsSubscriptionValid = (isSubscriptionValid) => {
  const user = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_CURRENT_USER)
  );
  localStorage.setItem(
    process.env.REACT_APP_CURRENT_USER,
    JSON.stringify({
      ...user,
      isSubscriptionValid,
    })
  );
};

export const getUser = () => {
  if (!localStorage.getItem(process.env.REACT_APP_CURRENT_USER)) {
    return EMPTY_USER;
  }

  const user = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_CURRENT_USER)
  );
  const currentWorkspace = workspaceService.getCurrentWorkspaceInfo();

  return {
    ...user,
    currentWorkspace,
  };
};

export const setToken = (token) => {
  Cookies.set(process.env.REACT_APP_AUTH_TOKEN, token);
};

export const isAuthenticated = () => {
  const token = Cookies.get(process.env.REACT_APP_AUTH_TOKEN);
  return token ? true : false;
};

export const logIn = async ({ email, password, idToken }) => {
  const path = idToken ? "/auth/google" : "/auth";

  const { data } = await httpService.post(path, {
    email,
    password,
    idToken,
  });
  const { user, jwt } = data;

  setToken(jwt);

  const { list: workspaces } = await workspaceService.list();

  const [currentWorkspace] = workspaces;

  await workspaceService.changeCurrentWorkspace(
    currentWorkspace._id,
    currentWorkspace
  );

  const info = {
    ...user,
    workspaces,
    isLoggedIn: true,
    currentWorkspace,
  };

  setUser(info);

  const lastPage = localStorage.getItem(process.env.REACT_APP_LAST_PAGE);

  if (lastPage) {
    const { isConfirmed } = await Swal.fire({
      title: "Deseja voltar para a última página?",
      showDenyButton: true,
      confirmButtonText: `Sim`,
      denyButtonText: `Não`,
    });

    if (isConfirmed) {
      window.location.href = lastPage;
    }

    localStorage.removeItem(
      process.env.REACT_APP_LAST_PAGE,
      window.location.pathname
    );
  }

  return info;
};

export const forgotPassword = async ({ identifier }) => {
  await httpService.post("/auth/password/reset", {
    identifier: removeFormatting(identifier),
  });
};

export const resetPassword = async ({
  code,
  password,
  passwordConfirmation,
}) => {
  const { data } = await httpService.put("/auth/password/reset", {
    code,
    password,
    passwordConfirmation,
  });

  return data;
};

export const logOut = () => {
  Cookies.remove(process.env.REACT_APP_AUTH_TOKEN);
  localStorage.removeItem(process.env.REACT_APP_CURRENT_USER);
  localStorage.removeItem(process.env.REACT_APP_CURRENT_WORKSPACE);
  localStorage.removeItem(process.env.REACT_APP_CURRENT_WORKSPACE_INFO);
};

export const setLastPage = (page) => {
  localStorage.setItem(process.env.REACT_APP_LAST_PAGE, page);
};
